"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSchemaDTO = void 0;
const index_js_1 = require("../../../schema/index.js");
const index_js_2 = require("./fromAttrDTO/index.js");
const fromSchemaDTO = (schemaDTO) => (0, index_js_1.schema)(Object.fromEntries(Object.entries(schemaDTO.attributes).map(([attributeName, attributeDTO]) => [
    attributeName,
    (0, index_js_2.fromAttrDTO)(attributeDTO)
])));
exports.fromSchemaDTO = fromSchemaDTO;
